import routers from "./modules/index";

export const staticRoute = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/login.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/login/register.vue"),
    meta: {
      title: "注册",
    },
  },
  {
    path: "/htmlContent",
    name: "htmlContent",
    component: () => import("@/views/common/htmlContent.vue"),
    meta: {
      title: "协议",
    },
  },
  ...routers,
];
